import {ActionTypes} from "./types";

const INITIAL_STATE = {
  notificationTemplates: undefined
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_NOTIFICATION_TEMPLATES:
      return {
        ...state,
        notificationTemplates: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;